import styled from 'styled-components'

export const SearchFilterContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 300px;
`

export const FilterWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const DropdownWrapper = styled.div`
  min-width: 200px;
`
